import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse} from "@angular/common/http"
import { BehaviorSubject, Subject,throwError } from 'rxjs';
import { User } from './user.module';
import{tap,catchError} from "rxjs/operators"
export interface AuthResponseData {
  kind?:string;
  idToken:string;
  email:string;
  refreshToken:string;
  expiresIn:string;
  localId:string
  registered?:boolean;}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
 apiKey:string="AIzaSyBcdty610Kp9vHBpTFQkhVip9-t0Kcc7ec"; //PAT-BOOK
 //apiKey:string="AIzaSyDiMpNijuptReemjKovadIOx_bQN2pdDsI"; OLD ACCOUNT
 user=new Subject<User>();
 token:string=""; //User token
 userMail:string="";//User mail
  constructor(private http:HttpClient) {   }
  signUp(email:string,password:string) {
  return  this.http.post<AuthResponseData>("https://identitytoolkit.googleapis.com/v1/accounts:signUp?key="+this.apiKey,{
      email:email,
      password:password,
      returnSecureToken:true,
    })
  }
  logIn(email:string,password:string) {
    return this.http.post<AuthResponseData>("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key="+this.apiKey, {
      email:email,
      password:password,
      returnSecureToken:true,
    }).pipe(catchError(this.handleError),tap(resData=>{
      const expirationDate=new Date(new Date().getTime()+ + (resData.expiresIn)*1000);
      const user=new User(resData.email, resData.localId,resData.idToken,expirationDate);
      this.user.next(user);
      this.token=user.token;
      this.userMail=user.email;
      }))
  }
  changePassword(email:string) {
    return this.http.post<AuthResponseData>("https://identitytoolkit.googleapis.com/v1/accounts:sendOobCode?key="+this.apiKey, {
      email:email,
      requestType:"PASSWORD_RESET",

    }).pipe(catchError(this.handleError),tap(resData=>{
     //console.log(resData)
      }))
  }
  logOut() {
    return  this.http.post<AuthResponseData>("https://identitytoolkit.googleapis.com/v1/accounts:signUp?key="+this.apiKey,{
        email:"",
        password:"",
        returnSecureToken:true,
      })
    }
    private handleError(errorRes: HttpErrorResponse) {
      let errorMessage = 'Lütfen internetinizi ve kayıt bilgilerinizi kontrol ediniz';
      if (!errorRes.error || !errorRes.error.error) {
        return throwError(errorMessage);
      }
      switch (errorRes.error.error.message) {
        case 'EMAIL_EXISTS':
          errorMessage = 'Bu e-posta adresi sistemimize daha önce kaydedilmiştir.';
          break;
        case 'EMAIL_NOT_FOUND':
          errorMessage = 'Bu e-posta sistemimize kayıtlı değildir';
          break;
        case 'INVALID_PASSWORD':
          errorMessage = 'Şifre hatalıdır.';
          break;
      }
      return throwError(errorMessage);
    }
}
